(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerTitleDialogController', CustomerTitleDialogController);

    CustomerTitleDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CustomerTitle'];

    function CustomerTitleDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CustomerTitle) {
        var vm = this;
        vm.customerTitle = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:customerTitleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.customerTitle.id !== null) {
                CustomerTitle.update(vm.customerTitle, onSaveSuccess, onSaveError);
            } else {
                CustomerTitle.save(vm.customerTitle, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
